import { motion } from "framer-motion";
import dayjs from "dayjs";
import { useReservations } from "@/lib/api";
import { UserAPI } from "@shared/types/api";
import { eventTimeToDaysjs } from "@/utils/dateUtils";
import InstallAppPitch from "./InstallAppPitch";
import { useShouldPitchAppInstall } from "../lib/useShouldPitchAppInstall";

const hasUpcomingBooking = (reservations: UserAPI.Reservation[]) =>
  reservations.some(
    (r) =>
      r.status === "active" && eventTimeToDaysjs(r.eventTime).isAfter(dayjs())
  );

/**
 * Permanent (non-dismissible) dashboard nudge to install the native app,
 * shown while the user has an upcoming booking but no registered app device.
 * Table assignments, the group chat, and day-of reminders arrive by push,
 * which never reaches web-only users — so getting booked users onto the app
 * directly protects attendance.
 */
export default function InstallAppBanner() {
  const shouldPitch = useShouldPitchAppInstall();
  const { data: reservationsData } = useReservations();

  if (!shouldPitch || !hasUpcomingBooking(reservationsData?.data || [])) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      // mt-5 clears the mobile logo header (mb-1 only); it's md:hidden, so no
      // extra top margin is needed from md up.
      className="mt-5 md:mt-0 mb-6"
    >
      <InstallAppPitch source="dashboard_install_banner" className="card p-5" />
    </motion.div>
  );
}
